import axios, { AxiosInstance } from "axios";
import store from "../store";

export const http: AxiosInstance = axios.create({
  baseURL: store.getters['config/getTestnetUrl']
});

const testnetApiInterceptor = http.interceptors.request.use(config => {
  config.baseURL = store.getters['config/getTestnetUrl'];
  store.dispatch('config/setFirstLoad');
  return config;
}, error => {
  console.error(error);
  Promise.reject(error);
})

if(store.getters['config/isFirstLoad']){
  http.interceptors.request.eject(testnetApiInterceptor);
}

export const http_main: AxiosInstance = axios.create({
  baseURL: store.getters['config/getMainnetUrl']
});

const mainnetApiInterceptor = http_main.interceptors.request.use(config => {
  config.baseURL = store.getters['config/getMainnetUrl'];
  store.dispatch('config/setFirstLoad');
  return config;
}, error => {
  console.error(error);
  Promise.reject(error);
})

if(store.getters['config/isFirstLoad']){
  http_main.interceptors.request.eject(mainnetApiInterceptor);
}

// export default apiSettings;